(function () {
  'use strict';

  function minimum(value) {
    var parsed = Number(value);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : 1;
  }

  function normalize(value, floor) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? Math.max(floor, Math.ceil(parsed)) : floor;
  }

  function init(doc) {
    var config = doc.getElementById('knox-product-rules');
    if (!config || config.dataset.initialized === 'true') return;
    var data;
    try { data = JSON.parse(config.textContent); } catch (_) { return; }
    var floor = minimum(data.minimum);
    if (floor === 1) return;
    var scope = doc.querySelector('#site-main') || doc.querySelector('main');
    if (!scope) return;
    config.dataset.initialized = 'true';
    var initialized = new WeakSet();
    var selector = 'input[name="contact[quantity]"]';
    function prepare(input, reset) {
      input.min = String(floor);
      input.step = '1';
      input.required = true;
      if (reset || !initialized.has(input)) {
        input.value = String(normalize(input.value, floor));
        initialized.add(input);
      }
    }
    function scan(reset) {
      scope.querySelectorAll(selector).forEach(function (input) { prepare(input, reset); });
    }
    scan(false);
    doc.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var opener = target.closest('[data-hw-quote-open],a[href="#software-request-form"],a[href="#product-request-form"]');
      if (opener && scope.contains(opener)) queueMicrotask(function () { scan(true); });
    }, true);
    doc.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !scope.contains(form)) return;
      var input = form.querySelector(selector);
      if (!input) return;
      prepare(input, false);
      if (!input.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.reportValidity();
      }
    }, true);
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (records) {
        var opened = records.some(function (record) {
          return record.type === 'attributes' && record.target.hasAttribute('open');
        });
        scan(opened);
      }).observe(scope, {childList:true, subtree:true, attributes:true, attributeFilter:['open']});
    }
  }

  if (typeof module === 'object' && module.exports) module.exports = {minimum:minimum, normalize:normalize, init:init};
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function () {
      init(document);
    });
  }
})();
